import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RequestInterface } from '@interface/logs/logs.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';

import { initialLogsState } from './logs.initial-state';

export const logsSlice = createSlice({
  name: 'logs',
  initialState: initialLogsState,
  reducers: {
    ...baseReducerActions(initialLogsState),
    setRequests: (state, { payload }: PayloadAction<ResponseDataInterface<RequestInterface[]>>) => {
      state.data.requests = payload.data;
    },
    setEvents: (state, { payload }: PayloadAction<ResponseDataInterface<any[]>>) => {
      state.data.events = payload.data;
    },
  },
});

export const logsActions = logsSlice.actions;
